<template lang="html">
  <div v-if="Boolean(school.district_id)" class="pl-title">
    NOTE: You cannot edit this school's membership because it is part of a
    district. To make teachers from this school paid users, you will need to
    create a membership at the district level
    <br />
    <pl-button @click.native="goToDistrict" class="pl-primary">
      Go to District</pl-button
    >
  </div>

  <div v-else>
    <h1>Manage school Memberships</h1>

    <h2>Active Memberships</h2>
    <ul>
      <li class="pl-subheading" v-for="membership in active_memberships">
        <strong>Expiry Date</strong>: {{ membership.end_date_readable }}
        <br />
        <strong>Date Started</strong>: {{ membership.start_date_readable }}
      </li>
    </ul>

    <h2>Previous (Expired) Memberships</h2>
    <ul>
      <li class="pl-subheading" v-for="membership in expired_memberships">
        <strong>Expiry Date</strong>: {{ membership.end_date_readable }}
        <br />
        <strong>Date Started</strong>: {{ membership.start_date_readable }}
      </li>
    </ul>

    <h2>Create New Membership</h2>

    <!-- Membership Date Picker -->
    <fieldset>
      <legend>Choose Membership Duration</legend>

      <div>
        <label for="start">Start Date</label>
        <input
          v-model="start_date"
          type="date"
          id="start"
          name="membership-selection"
          required
        />
      </div>

      <div>
        <label for="end">End Date</label>
        <input
          v-model="end_date"
          type="date"
          id="end"
          name="membership-selection"
          required
        />
      </div>
    </fieldset>

    <!-- Create New Membership Button -->
    <div>
      <pl-button class="pl-primary" @click.native="createNewSchoolMembership">
        Create New
      </pl-button>
    </div>
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';
  import moment from 'moment';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        memberships: [],
        start_date: '',
        end_date: '',
        school: { clever_id: '123' },
      };
    },
    computed: {
      expired_memberships() {
        return this.memberships.filter((membership) => {
          // Return true if right now (`moment()`) is after the end date of the membership
          return moment().isAfter(membership.end_date);
        });
      },
      active_memberships() {
        return this.memberships.filter((membership) => {
          // Return true if right now (`moment()`) is before the end date of the membership
          return moment().isBefore(membership.end_date);
        });
      },
    },
    methods: {
      goToDistrict() {
        const { district_id } = this.school;
        this.$router.push(`/admin-view-individual-district/${district_id}`);
      },
      createNewSchoolMembership() {
        const has_confirmed = confirm(
          'Are you sure you want to create a new school membership? All teachers that belong to this school will have their memberships extended to the End Date you have selected'
        );
        if (has_confirmed) {
          const payload = {
            school_id: this.$route.params.schoolID,
            end_date: this.end_date,
            start_date: this.start_date,
          };
          adminServices
            .createSchoolMembership(payload)
            .then((res) => {
              this.memberships.push(res.data);
              this.end_date = '';
              this.start_date = '';
              EventBus.$emit('toast-msg', 'success');
            })
            .catch((err) => {
              EventBus.$emit('alert-msg', err.response.data.message);
            });
        }
      },
    },
    mounted() {
      const { schoolID } = this.$route.params;
      adminServices
        .getSchool(schoolID)
        .then((res) => {
          this.school = res.data;
        })
        .catch(console.log);
      adminServices
        .getSchoolMemberships(schoolID)
        .then((res) => {
          this.memberships = res.data;
        })
        .catch(console.log);
    },
  };
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// manageSchoolMembership.vue?a8227c64